





import { defineComponent, onBeforeUnmount, ref, toRef, watch } from "@vue/composition-api";
import simplebar from "simplebar-vue";
import { isMacOS, isMobile } from "@/lib/browserUtils";

export default defineComponent({
  name: "CustomScroll",
  components: { simplebar },
  props: {
    observerRef: { type: Element },
  },
  setup(props) {
    const observableElement = toRef(props, "observerRef");

    const customScroll = ref();
    const contentHeight = ref(0);

    const useNativeScroll = isMobile() || isMacOS();

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        contentHeight.value = entry.borderBoxSize[0].blockSize;
      }
    });

    const observeBody = () => {
      if (!observableElement.value) return;
      resizeObserver.observe(observableElement.value);
    };

    watch(contentHeight, (value, oldValue) => {
      if (value === oldValue) return;
      customScroll.value?.SimpleBar?.recalculate();
    });
    watch(
      observableElement,
      () => {
        if (!useNativeScroll && props.observerRef) observeBody();
      },
      { immediate: true }
    );

    onBeforeUnmount(() => resizeObserver.disconnect());

    return {
      customScroll,
      useNativeScroll,
    };
  },
});
